export default __webpack_public_path__ + "static/media/wifi.d3038a10.svg";